export default [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'eventable_type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total_amount' },
  { label: 'Ret. IR', value: 'income_tax_total' },
  { label: 'Filial da empresa', value: 'client_branch' },
  { label: 'Cartão', value: 'card' },
  { label: 'Data e Hora', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
